module.exports = __webpack_public_path__ + "img/7ef47e3.jpg";